module.exports = __webpack_public_path__ + "img/ai-summary-active.ac118bcc.png";